export const formatDate = (value, fallback = "--") => {
  if (value === undefined || value === null || value === "") return fallback;
  return String(value);
};

export const formatDateTime = (value, fallback = "--") => {
  if (value === undefined || value === null || value === "") return fallback;
  return String(value);
};

export const formatDateInput = (value) => {
  if (!value) return "";

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, "0");
    const day = String(value.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return String(value);
  }

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
